<template>
	<ejs-dialog :buttons='alertDlgButtons' ref="popup" v-bind:visible="false" :header='title' :animationSettings='animationSettings' :content='alertContent' :showCloseIcon='false' target='.control-section'
		width='550px' :isModal='true'>
  </ejs-dialog>
	<div v-if="$keycloak && $keycloak.authenticated" class="flex flex-row justify-center gap-6">
		<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="sendOfferToCustomer">{{title}}</button>
	</div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { DialogComponent } from "@syncfusion/ej2-vue-popups";

export default {
	name: "SendEmailButton",
	components: {
		'ejs-dialog': DialogComponent,
	},
	data() {
		return {
			// dialog data
			title: this.$t('eny.send_offer_to_customer'),
			alertContent: '',
			animationSettings: { effect: 'None' },
			alertDlgButtons: [
				{ click: this.offerCloseDlgBtnClick, buttonModel: { content: this.$t('eny.end_application'), isPrimary: false } },
				{ click: this.correctDlgBtnClick, buttonModel: { content: this.$t('eny.send_email_ok_button'), isPrimary: true } }
			],
		};
	},
	computed: {
		...mapGetters('customer', ['send_email_message']),
	},
	watch: {
		//show "email send" responce in popup dialog 
		send_email_message(value) {
			if (value) {
				this.alertContent = value;
				this.$refs.popup.show();
			}
		}
	},
	methods: {
		...mapMutations('customer', ['RESET_SEND_EMAIL_MESSAGE']),
		sendOfferToCustomer: function() {
			this.$store.dispatch('customer/sendOffer', {showPopup: true});
		},
		correctDlgBtnClick: function() {
			this.$refs.popup.hide();
			this.RESET_SEND_EMAIL_MESSAGE();
		},
		offerCloseDlgBtnClick: function() {
			this.RESET_SEND_EMAIL_MESSAGE();
			this.$store.dispatch('customer/store_status', 0);
			this.$store.dispatch('customer/reset');
			this.$refs.popup.hide();
			this.$router.push('/offer');
		},
	}
}
</script>